import { render, staticRenderFns } from "./MemberDocumentComponent.vue?vue&type=template&id=bdd515ba&scoped=true&"
import script from "./MemberDocumentComponent.vue?vue&type=script&lang=js&"
export * from "./MemberDocumentComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberDocumentComponent.vue?vue&type=style&index=0&id=bdd515ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd515ba",
  null
  
)

export default component.exports